module.exports = __webpack_public_path__ + "img/hero-new3.f9caf64a.webp";